export default class CommonFunctions {
    getRequest(url, successCallback, errorCallback) {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onreadystatechange = function() {
            if (xhr.readyState != 4) {
                return;
            }
            if (xhr.status == 200) {
                successCallback(JSON.parse(xhr.responseText));
            } else if (xhr.status == 403) {
                window.location.reload();
            } else {
                errorCallback(xhr, xhr.status);
            }
        };
        xhr.onerror = function() {
            errorCallback(xhr, xhr.status);
        };
        xhr.send();
    }

    populateDropDown(firstProducts, dropDownContainer) {
        let searchTypes = {
            'all': 'All',
            'paym': 'Pay Monthly',
            'paymupgrade': 'Upgrades',
            'simonly': 'Sim Only',
            'simfree': 'Sim Free',
            'payg': 'Pay As You Go',
            'Accessory': 'Accessories'
        };
        firstProducts.forEach((product) => {
            let dropDownItem = document.createElement('a');
            if (typeof product.anchor_suffix !== 'undefined') {
                dropDownItem.innerHTML = product.anchor + ' in <strong>' + searchTypes[product.anchor_suffix] + '</strong>';
            } else {
                dropDownItem.innerHTML = product.anchor;
            }
            dropDownItem.setAttribute('href', product.url);
            dropDownItem.setAttribute('data-product-search', 'productSearchLinks');
            dropDownItem.setAttribute('class', 'dropdown-item');

            let dropDownLinkDivider = document.createElement('div');
            dropDownLinkDivider.setAttribute('class', 'dropdown-divider');
            dropDownItem.appendChild(dropDownLinkDivider);

            dropDownContainer.appendChild(dropDownItem);
            dropDownContainer.classList.remove('hide');
            dropDownContainer.classList.add('show');
        });
    }

    showSearchLoading() {
        let searchLoading = '[data-product-search-loading]';
        document.querySelector(searchLoading).classList.remove('hide');
        document.querySelector(searchLoading).classList.add('show');
    }

    hideSearchLoading() {
        let searchLoading = '[data-product-search-loading]';
        document.querySelector(searchLoading).classList.remove('show');
        document.querySelector(searchLoading).classList.add('hide');
    }

    closeAllSelect(elmnt) {
        let arrNo = [];
        let x = document.getElementsByClassName('select-items');
        let y = document.getElementsByClassName('select-selected search-box-options');
        const xl = x.length;
        const yl = y.length;
        for (let i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i);
            } else {
                y[i].classList.remove('select-arrow-active');
            }
        }
        for (let i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add('select-hide');
            }
        }
    }

    checkForEmptyResponse(response) {
        let resultCount = 0;
        for (const value of Object.values(response)) {
            if (value.length) {
                resultCount = resultCount + value.length;
            }
        }
        return resultCount;
    }

    populateNullOrLoadingText(dropDownContainer, isLoading) {
        dropDownContainer.innerHTML = '';
        let dropDownItem = document.createElement('div');
        let dropDownLink = document.createElement('span');
        if (isLoading === true) {
            dropDownLink.innerHTML = 'Hold tight... we won\'t be long.';
        } else {
            dropDownLink.innerHTML = 'No results... I wonder where you are';
        }
        dropDownLink.setAttribute('class', 'dropdown-item');
        dropDownItem.appendChild(dropDownLink);
        dropDownContainer.appendChild(dropDownItem);
        dropDownContainer.classList.remove('hide');
        dropDownContainer.classList.add('show');
    }

    makeRequest(dealType, value, dropDownContainer) {
        this.getRequest(
            '/search?dealType=' + dealType + '&query=' + value,
            (response) => {
                let resultCount = this.checkForEmptyResponse(response);
                dropDownContainer.innerHTML = '';
                if (resultCount > 0) {
                    this.populateDropDown(response.product_first, dropDownContainer);
                    this.populateDropDown(Object.values(response.product), dropDownContainer);
                    this.populateDropDown(response.cms, dropDownContainer);
                    this.populateDropDown(response.accessories, dropDownContainer);
                } else {
                    this.populateNullOrLoadingText(dropDownContainer, false);
                }
                this.hideSearchLoading();
            },
            () => {
                this.populateNullOrLoadingText(dropDownContainer, false);
                this.hideSearchLoading();
            }
        );
    }
}
